import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'pupco',
} as IModuleProps;
